export const inputCls = "w-full bg-white/70 border border-[#D5B98C] px-3 py-2.5 text-sm outline-none focus:border-[#39251D] transition-colors";
export const btnPrimary = "inline-flex items-center justify-center gap-2 bg-[#39251D] text-[#F5F0E8] px-5 py-2.5 text-xs uppercase tracking-[0.18em] hover:bg-[#956842] transition-colors disabled:opacity-40 disabled:cursor-not-allowed";
export const btnGhost = "inline-flex items-center justify-center gap-2 border border-[#D5B98C] px-4 py-2.5 text-xs uppercase tracking-[0.15em] hover:border-[#39251D] transition-colors disabled:opacity-40 disabled:cursor-not-allowed";

export const PageHead = ({ title, subtitle, children }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
    <div>
      <h1 className="font-serif text-3xl sm:text-4xl text-[#39251D]">{title}</h1>
      {subtitle && <p className="text-sm text-[#242321]/60 mt-1">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

export const Panel = ({ title, children, className = "", testId, actions }) => (
  <section data-testid={testId} className={`bg-white/60 border border-[#D5B98C]/60 p-4 sm:p-6 ${className}`}>
    {(title || actions) && (
      <div className="flex items-center justify-between gap-3 mb-5">
        {title && <h2 className="font-serif text-2xl text-[#39251D]">{title}</h2>}
        {actions}
      </div>
    )}
    {children}
  </section>
);

const PSTATUS = { draft: ["Bozza", "bg-[#D5B98C]/40 text-[#39251D]"], published: ["Pubblicato", "bg-[#3d5a3a] text-[#F5F0E8]"], archived: ["Archiviato", "bg-[#242321]/10 text-[#242321]/60"] };
export const ProductStatus = ({ status, testId }) => (
  <span data-testid={testId} className={`inline-block px-2 py-1 text-[10px] uppercase tracking-[0.15em] ${PSTATUS[status]?.[1]}`}>{PSTATUS[status]?.[0]}</span>
);

export const Field = ({ label, children, hint }) => (
  <label className="block">
    <span className="flex items-center gap-2 mb-1.5 text-[11px] uppercase tracking-[0.18em] text-[#956842]">{label}</span>
    {children}
    {hint && <span className="block mt-1 text-[11px] text-[#242321]/50">{hint}</span>}
  </label>
);
